import { createContext, useContext, useEffect, useState } from "react";
import { useTutor } from "./AiTutorContext";
import useStateRef from "react-usestateref";
import {
  classifierInitialState,
  ERROR_MESAGES,
  generateNewChatId,
  HTTP_CODES,
  LOADING_MESSAGE,
  summaryInitialState,
} from "../utils/TutorConstants";
import { chatConversation } from "../api/ai-tutor/doubt-service";
import {
  fetchChatHistory,
  fetchConvMedia,
  fetchSummary,
  getImageMetaData,
  getVideoMetada,
  saveAsFavorite,
} from "../network/TutorApiService";
import { isEmptyOrNull, urlString } from "../utils/common-utils";
import { useCustomToast } from "../components/molecules/ai-tutor/useCustomToast";
import { useRoot } from "./RootContext";
import { useAudio } from "./AudioContext";
import { Box, Text, useToast } from "@chakra-ui/react";
import { useNavigate } from "@remix-run/react";
import { getNavStack, ROUTES } from "../utils/navigationUtils";

const DoubtContext = createContext();
export const DoubtProvider = ({ children }) => {
  const {
    openDoubtSideMenu,
    setTopicName,
    setSubjectName,
    isPlayground,
    autoPlay,
    isStandalone,
  } = useRoot();
  const {
    setLoader,
    setGrade,
    setSubject,
    setTopic,
    setUserQuery,
    setIsCompleted,
    isCompleted,
    userQuery,
    loader,
    setClassifierInfo,
    curriculumObj,
    setIsFeedbackSubmitted,
    doubtQuestionObj,
    setDoubtQuestionObj,
    loaderText,
    setLoaderText,
  } = useTutor();
  const showToast = useCustomToast();
  const { handlePlayPause, handleResetAudio } = useAudio();
  const toast = useToast();
  const [chatHistory, setChatHistory, chatHistoryRef] = useStateRef([]);
  const [chatQuery, setChatQuery, chatQueryRef] = useStateRef("");
  const [streamingText, setStreamingText, streamingTextRef] = useStateRef("");
  const [chatId, setChatId, chatIdRef] = useStateRef("");
  const [isConvCompleted, setIsConvCompleted, isConvCompletedRef] =
    useStateRef(false);
  const [summaryInfo, setSummaryInfo, summaryInfoRef] =
    useStateRef(summaryInitialState);
  const [isRefresh, setIsRefresh, isRefreshRef] = useStateRef(false);
  const [pocketType, setPocketType, pocketTypeRef] = useStateRef("");
  const [isOutOfTopic, setIsOutOfTopic, isOutOfTopicRef] = useStateRef(false);
  const [inputStatus, setInputStatus, inputStatusRef] = useStateRef(1);
  const [chatIndex, setChatIndex, chatIndexRef] = useStateRef(0);
  const [showHintBtn, setShowHintBtn, showHintBtnRef] = useStateRef(false);
  const [contextQuery, setContextQuery, contextQueryRef] = useStateRef("");
  const [mediaDetails, setMediaDetails, mediaDetailsRef] = useStateRef([]);
  const [summaryList, setSummaryList, summaryListRef] = useStateRef([]);
  const [userChat, setUserChat, userChatRef] = useStateRef([]);
  const [selectedSummary, setSelectedSummary, selectedSummaryRef] = useStateRef(
    {}
  );
  const [userActions, setUserActions, userActionsRef] = useStateRef({});
  const [assistantRefImages, setAssistantRefImages] = useState([]);
  const [showEndConv, setShowEndConv] = useState(false);
  const [forceEnded, setForceEnded] = useState(false);
  const [endedQuery, setEndedQuery] = useState("");
  const [doubtState, setDoubtState] = useState(2);
  const [needClarification, setNeedClarification] = useState(false);
  const [tryCount, setTryCount, tryCountRef] = useStateRef(0);
  const [allowImagePull, setAllowImagePull] = useState(true);
  const [backToSyllabus, setBackToSyllabus, backToSyllabusRef] =
    useStateRef(false);

  const { summary, showSummary, isSummaryCompleted } = summaryInfoRef?.current;

  const navigate = useNavigate();

  useEffect(() => {
    if (backToSyllabus) {
      const hasSyllabusInStack = getNavStack().includes(ROUTES.SYLLABUS);

      if (hasSyllabusInStack) {
        navigate(ROUTES.SYLLABUS);
      } else {
        navigate(ROUTES.HOME);
      }
    }
  }, [backToSyllabus]);

  useEffect(() => {
    handleReset();
    setSummaryList([]);
    setUserChat([]);
    setSelectedSummary([]);
  }, []);

  useEffect(() => {
    if (isCompleted && streamingText !== "") {
      handleUpdateChatHistory();
    }
  }, [streamingText, isCompleted]);

  useEffect(() => {
    if (openDoubtSideMenu) {
      retrieveSummary();
    }
  }, [openDoubtSideMenu]);

  const handleOffTopicCheck = async (headers) => {
    let offTopicKey = await headers.get("off_topic_check");
    if (offTopicKey == 1) {
      setIsOutOfTopic(true);
      setLoader(false);
      setStreamingText("  ");
      setIsCompleted(true);
      return true;
    } else {
      setIsOutOfTopic(false);
      return;
    }
  };
  const handleContxtCheck = async (headers) => {
    let contxtCheck = await headers.get("context_refresh_check");
    if (contxtCheck == 1) {
      setDoubtState(2);
      setIsRefresh(true);
      setLoader(false);
      setStreamingText("  ");
      setIsCompleted(true);
      return true;
    } else {
      setIsRefresh(false);
      return;
    }
  };
  const handleResponseHeaders = async (headers, query, question) => {
    const { off_topic_continue, context_refresh_continue } =
      userActionsRef?.current || {};
    const isAllow = await headers.get("allow_imagepull");
    if (isAllow != null) {
      console.log("Allow Image Pull --->" + isAllow);
      setAllowImagePull(isAllow == "true");
    }
    let inputStatus = await headers.get("input_length_status");
    setInputStatus(inputStatus);
    //checking for context setting query
    if (isEmptyOrNull(contextQuery)) {
      let status = await headers.get("Context_setting_status");
      if (status == 1) {
        setDoubtState(0);
        if (isEmptyOrNull(question?.version_uuid)) {
          fetchVideoInformation(query);
          setContextQuery(query);
        } else {
          setContextQuery(question?.question_layout);
        }
      }
    }
    //End
    //Off Topic Check
    if (chatHistoryRef?.current?.length == 0 && !off_topic_continue) {
      let status = await handleOffTopicCheck(headers);
      return status;
    }
    //End
    //Context Refresh Check
    if (!context_refresh_continue && chatHistoryRef?.current?.length > 0) {
      let status = await handleContxtCheck(headers);
      return status;
    }
    //End
  };

  const prepareMediaInput = (query) => {
    let mediaParams = {
      query: query,
      chat_history: chatHistoryRef?.current || [],
    };
    mediaParams = { ...mediaParams, ...curriculumObj };
    return mediaParams;
  };

  const fetchVideoInformation = async (query) => {
    let body = prepareMediaInput(query);
    body.k = "3";
    body.context_setting_query = query;
    let response = await getVideoMetada(
      body,
      chatIdRef?.current,
      chatIndexRef?.current
    );
    setMediaDetails(response?.data || []);
  };
  const fetchImageInformation = async (query) => {
    let body = prepareMediaInput(query);
    body.k = "3";
    let { data = [] } = await getImageMetaData(
      body,
      chatIdRef?.current,
      chatIndexRef?.current
    );
    setAssistantRefImages(data);
  };

  const getConversationMedia = async (chatId) => {
    let response = await fetchConvMedia(chatId);
    let imagedata = response?.find((item) => item?.media_type == "image");
    let videoData = response?.find((item) => item?.media_type == "video");
    setMediaDetails(videoData?.mediaInfo || []);
    setAssistantRefImages(imagedata?.mediaInfo || []);
  };
  const handleUpdateChatHistory = async () => {
    const currentChat = [
      {
        role: "user",
        content: chatQuery,
        input_status: inputStatusRef?.current,
        chatID: chatIdRef?.current,
      },
      {
        role: "assistant",
        content: streamingText,
        input_status: inputStatusRef?.current,
        chatID: chatIdRef?.current,
      },
    ];
    let updatedHistory = [...chatHistoryRef?.current, ...currentChat];
    let convLength = updatedHistory?.filter(
      (item) =>
        item?.role == "assistant" && !isEmptyOrNull(item?.content?.trim())
    )?.length;

    const enableHintBtn =
      convLength >= parseInt(window?.ENV?.SHOW_HINT_BUTTON_AFTER || 2);
    const enableConclude =
      convLength >= parseInt(window?.ENV?.SHOW_CONCLUDE_BUTTON_AFTER || 4);

    if (
      (enableConclude || isRefreshRef?.current) &&
      !isConvCompletedRef?.current
    ) {
      setShowEndConv(true);
    }
    if (!isConvCompletedRef?.current && enableHintBtn) {
      setShowHintBtn(true);
    }

    if (window?.ENV?.ENABLE_VOICE == "true" && autoPlay) {
      const playingIndex = `${chatIdRef?.current}-${convLength}`;
      handlePlayPause(
        playingIndex,
        streamingText,
        chatIdRef?.current,
        chatIndexRef?.current,
        false,
        ""
      );
    }
    setChatHistory(updatedHistory);
    setChatIndex(convLength);
    setChatQuery("");
    setStreamingText("");
    setIsCompleted(false);
    setInputStatus(1);
  };

  const handleStreaming = (chunk, isSummary) => {
    if (isSummary) {
      setSummaryInfo((prev) => {
        return { ...prev, summary: prev?.summary + chunk };
      });
    } else {
      setStreamingText((prev) => {
        let updatedChunk = prev + chunk;
        if (updatedChunk?.includes("#*#*#")) {
          setDoubtState(1);
          setIsConvCompleted(true);
          setShowEndConv(true);
          setNeedClarification(true);
        }
        return updatedChunk;
      });
    }
  };
  const retrieveSummary = async () => {
    const response = await fetchSummary();
    if (response?.length > 0) {
      setSummaryList(response);
    }
  };
  const retrieveUserChat = async (chat_id) => {
    const response = await fetchChatHistory(chat_id);
    if (response?.length > 0) {
      setUserChat(response);
    }
  };
  const prepareChatInput = (query) => {
    const { off_topic_continue, context_refresh_continue } =
      userActionsRef?.current || {};
    let existingHis = chatHistoryRef?.current?.filter(
      (item) => item.input_status != 0
    );
    existingHis = existingHis?.map((item) => {
      let existing = { ...item };
      delete existing?.input_status;
      delete existing?.chatID;
      return { ...existing };
    });
    let inputParams = {
      query: query || chatQueryRef?.current,
      chat_history: existingHis,
      image_metadata: [],
    };
    inputParams = { ...inputParams, ...curriculumObj };
    delete inputParams.shortcut_fill;
    if (query == "I need a Hint") {
      inputParams["shortcut_fill"] = 1;
    }
    if (off_topic_continue) {
      inputParams["off_topic_continue"] = off_topic_continue;
    }
    if (context_refresh_continue) {
      inputParams["context_refresh_continue"] = true;
    }
    return inputParams;
  };
  const handleDoubtFlow = async (query, question, isRetry) => {
    if (isEmptyOrNull(question?.version_uuid)) {
      question = { ...doubtQuestionObj };
    }
    let body = prepareChatInput(query);
    body["interaction_type"] = "conversation";
    if (isPlayground) {
      body["playground_status"] = 1;
    }
    if (question?.version_uuid) {
      body["question_uuid"] = question?.version_uuid;
    }
    if (isRetry) {
      body.retry_status = true;
      body.retry_index = tryCountRef?.current;
    }
    const convInput = {
      inputParams: body,
      setLoader,
      chat_id: chatIdRef?.current,
      isSummary: undefined,
      setIsCompleted,
      handleStreaming,
      chatIndex: chatIndexRef?.current,
      handleResponseHeaders: async (headers) => {
        return await handleResponseHeaders(headers, query, question);
      },
      handleCompleted: () => {},
      setLoaderText,
    };

    setChatQuery(query);
    setUserQuery("");
    setLoader(true);
    setIsCompleted(false);
    setShowHintBtn(false);
    setUserActions({});

    if (isEmptyOrNull(body?.question_uuid) && !isRetry && allowImagePull) {
      await fetchImageInformation(query);
    }

    const { success = false, status = "" } = await chatConversation(convInput);
    console.log(success, status);
    if (!success) {
      if (status == HTTP_CODES.BAD_REQUEST) {
        setTryCount(0);
        setIsConvCompleted(true);
        setForceEnded(true);
        showToast({
          description: ERROR_MESAGES.BAD_REQUEST,
          status: "error",
          duration: 3000,
        });
      } else {
        setStreamingText("");
        handleRetryFlows(query, question);
      }
    } else {
      setTryCount(0);
    }
  };

  const handleRetryFlows = (query, question) => {
    if (tryCountRef?.current <= 1) {
      setTryCount((prev) => prev + 1);
      if (isEmptyOrNull(loaderText)) {
        setLoaderText(LOADING_MESSAGE);
        setIsCompleted(false);
        setLoader(true);
      }
      setTimeout(() => {
        handleDoubtFlow(query, question, true);
      }, 2000);
    } else {
      setTryCount(0);
      setLoaderText("");
      setIsConvCompleted(true);
      setForceEnded(true);
      showToast({
        description: ERROR_MESAGES.SERVER_ERROR,
        status: "error",
        duration: 3000,
      });
    }
  };

  const handleContinueConv = () => {
    if (isOutOfTopic) {
      setUserActions((prev) => {
        return { ...prev, off_topic_continue: true };
      });
      setIsOutOfTopic(false);
      let updatedHistory = [...chatHistoryRef?.current?.slice(-2)];
      setChatHistory([]);
      let query = updatedHistory?.[0]?.content;
      setChatQuery(query);
      setLoader(true);
      handleDoubtFlow(query);
    } else if (isRefresh) {
      setIsRefresh(false);
      setUserActions((prev) => {
        return { ...prev, context_refresh_continue: true };
      });
      let lastRow = [...chatHistoryRef?.current?.slice(-2)];
      let query = lastRow?.[0]?.content;
      let existing = [...chatHistoryRef?.current];
      existing.splice(existing.length - 2, 2);
      setChatHistory(existing);
      handleDoubtFlow(query);
      setDoubtState(isEmptyOrNull(contextQuery) ? 2 : 0);
    } else {
      setNeedClarification(false);
      setIsConvCompleted(false);
      setShowEndConv(false);
      setDoubtState(2);
    }
  };
  const handleFetchSummary = async () => {
    let body = prepareChatInput();
    delete body.query;
    body["interaction_type"] = "summary";
    if (doubtQuestionObj?.version_uuid) {
      body["question_uuid"] = doubtQuestionObj?.version_uuid;
    }
    setLoader(true);
    const inputBody = {
      inputParams: body,
      setLoader,
      chat_id: chatIdRef?.current,
      isSummary: true,
      setIsCompleted,
      handleStreaming,
      chatIndex,
      handleResponseHeaders: () => {},
      handleCompleted: () => {
        setSummaryInfo((prev) => {
          return { ...prev, isSummaryCompleted: true };
        });
        if (window?.ENV?.ENABLE_VOICE == "true") {
          if (autoPlay) {
            const playingIndex = `${chatIdRef?.current}-summary`;
            handlePlayPause(
              playingIndex,
              summaryInfoRef?.current?.summary,
              chatIdRef?.current,
              chatIndexRef?.current,
              false,
              ""
            );
          }
        }
      },
      setLoaderText,
    };
    await chatConversation(inputBody);
  };
  const handleShowSummary = async () => {
    setIsConvCompleted(true);
    setShowEndConv(false);
    setShowHintBtn(false);
    setNeedClarification(false);
    if (isRefresh) {
      let history = [...chatHistoryRef?.current];
      let size = history.length;
      let tailPart = [...history.splice(size - 2, size)];
      tailPart = tailPart?.find((item) => item?.role == "user");
      setEndedQuery(tailPart?.content);
      setChatHistory(history);
      setIsRefresh(false);
      setPocketType("OutOfContext");
      if (isEmptyOrNull(contextQuery)) {
        setForceEnded(true);
        return;
      }
    }

    if (isEmptyOrNull(contextQuery)) {
      setForceEnded(true);
      return;
    }
    setSummaryInfo((prev) => {
      return { ...prev, showSummary: true };
    });
    handleFetchSummary();
  };

  const handleReset = (type = "reset") => {
    handleResetAudio();
    setDoubtQuestionObj({});
    setShowEndConv(false);
    setForceEnded(false);
    setAllowImagePull(true);
    setContextQuery("");
    if (type != "re-execute") {
      setEndedQuery("");
    }
    if (isEmptyOrNull(selectedSummary?.chat_uuid)) {
      setMediaDetails([]);
      setAssistantRefImages([]);
    }
    if (type == "reset") {
      setClassifierInfo(classifierInitialState);
      setGrade("");
      setSubject("");
      setTopic("");
      setTopicName("");
      setSubjectName("");
    }
    setSummaryInfo(summaryInitialState);
    setUserActions({});
    setShowHintBtn(false);
    setChatHistory([]);
    setChatQuery("");
    setStreamingText("");
    setChatId(generateNewChatId());
    setIsConvCompleted(false);
    setIsRefresh(false);
    setPocketType("");
    setChatIndex(0);
    setIsFeedbackSubmitted(false);
  };
  const handleSendToPocket = async (customText) => {
    const sQuery = isEmptyOrNull(contextQuery)
      ? chatHistoryRef?.current?.[0]?.content
      : contextQuery;
    const body = {
      selected_query: customText,
      chat_uuid: chatIdRef?.current,
      query: sQuery,
      summary: summary || "",
      topic_name: curriculumObj?.topic_name,
    };
    const response = await saveAsFavorite(body);
    if (response != undefined) {
      toast({
        position: "bottom",
        duration: 1500,
        render: () => (
          <Box
            bg="#E1FAC9"
            border="1px solid"
            borderColor="#79BA40"
            borderRadius="8px"
            position="fixed"
            bottom="150px"
            left={{ base: "10%", md: "24%", lg: "40%" }}
            zIndex="1000"
            minWidth="250px"
            padding={"15px 56px"}
          >
            <Text fontSize={"16px"} lineHeight={"24px"} color={"#5E8D34"}>
              Successfully sent to the pocket!
            </Text>
          </Box>
        ),
      });
      setIsFeedbackSubmitted(false);
      setSummaryInfo(summaryInitialState);
      setContextQuery("");
      if (pocketTypeRef?.current == "OutOfContext") {
        setChatIndex(0);
        handleReset("re-execute");
        if (!isEmptyOrNull(endedQuery)) {
          handleDoubtFlow(endedQuery);
        }
      } else if (isConvCompleted) {
        if (isStandalone) {
          handleReset("reset");
        } else {
          navigate(`${urlString}/syllabus`, { replace: true });
        }
      }
    }
  };
  const handleAskNewQuestion = () => {
    handleReset("continue");
  };
  const handleSwitchTopic = () => {
    setIsOutOfTopic(false);
    handleReset();
  };

  let summarySection =
    Object.keys(selectedSummaryRef?.current || {})?.length > 0 ||
    userChatRef?.current?.length > 0;

  const isStreamingCompleted =
    isCompleted == false &&
    isEmptyOrNull(streamingTextRef?.current) &&
    isEmptyOrNull(chatQueryRef?.current);
  const switchContext = isRefreshRef?.current && isStreamingCompleted;
  const showPocketBtn = isSummaryCompleted || forceEnded;
  let isEnableSubmitBtn =
    userQuery?.trim()?.length > 0 &&
    streamingTextRef?.current?.length == 0 &&
    loader == false;
  let allowToEnter = streamingTextRef?.current?.length == 0 && loader == false;
  let seeConversationBtn = summarySection && userChat?.length === 0;

  const buttons = {
    switchContext,
    showEndConv: showEndConv && isStreamingCompleted,
    showPocketBtn,
    isEnableSubmitBtn,
    allowToEnter,
    isOutOfTopic,
    showHintBtn: showHintBtnRef?.current,
    handleHintClick: () => {
      handleDoubtFlow("I need a Hint");
    },
    handleDoubtFlow,
    doubtState,
    needClarification,
    seeConversationBtn,
  };

  const state = {
    handleDoubtFlow,
    chatId: chatIdRef?.current,
    chatIndex: chatIndexRef?.current,
    chatQuery: chatQueryRef?.current,
    streamingText: streamingTextRef?.current,
    chatHistory: chatHistoryRef?.current,
    summaryInfo: summaryInfoRef?.current,
    isRefresh: isRefreshRef?.current,
    isConvCompleted: isConvCompletedRef?.current,
    handleContinueConv,
    handleShowSummary,
    handleSendToPocket,
    buttons,
    summaryList: summaryListRef?.current,
    selectedSummary: selectedSummaryRef?.current,
    setSelectedSummary,
    setUserChat,
    userChat: userChatRef?.current,
    retrieveUserChat,
    summarySection,
    handleReset,
    isOutOfTopic: isOutOfTopicRef?.current,
    handleSwitchTopic,
    handleAskNewQuestion,
    setShowHintBtn,
    contextQuery: contextQueryRef?.current,
    setContextQuery,
    mediaDetails: mediaDetailsRef?.current,
    setMediaDetails,
    getConversationMedia,
    assistantRefImages,
    setBackToSyllabus,
    backToSyllabus: backToSyllabusRef?.current,
  };
  return (
    <DoubtContext.Provider value={state}>{children}</DoubtContext.Provider>
  );
};
export const useDoubt = () => {
  return useContext(DoubtContext);
};
